// components/TextInput.tsx
import { useFormContext } from 'react-hook-form';

import { cn } from '@/lib/utils';
import type { GeneralFormProps } from '@/types/general';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form';
import { Switch } from '../ui/switch';

type Props = {
  className?: string;
  value?: boolean;
} & GeneralFormProps;

function RHFShadcnSwitch({
  name,
  title,
  description,
  value: externalValue,
  onChange: externalOnChange,
  className,
  required,

  disabled = false,
}: Props) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem
          className={cn(
            'flex flex-row items-center justify-between rounded-lg',
            className,
          )}
        >
          <div className="space-y-0.5">
            <FormLabel className="text-base">{title}</FormLabel>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage className="mt-1" />
          </div>
          <FormControl>
            <Switch
              required={required}
              data-testid={field.name}
              disabled={disabled}
              onCheckedChange={(e) => {
                if (externalOnChange) {
                  externalOnChange(e);
                  return;
                }
                field.onChange(e);
              }}
              checked={
                (field.value !== undefined
                  ? field.value
                  : externalValue) as boolean
              }
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}

export default RHFShadcnSwitch;
